export default __webpack_public_path__ + "static/media/Licenses_IMG-License-01.8e4fd0e3.png";